module.exports = __webpack_public_path__ + "static/media/family-over.f46275cc.svg";